import { t } from 'ttag';

export default (state = {}, action) => {
  switch (action.type) {
    case 'IS_POSTING_TO_CART':
      return {
        ...state,
        isPosting: true,
        error: false,
      };
      case 'IS_POSTING_CUSTOMIZATION':
    return {
      ...state,
      isPosting: true,
      error: false,
    };
    case 'POSTING_CUSTOMIZATION_SUCCESS': {
      const newState = {
        ...state,
        isPosting: false,
        response_data: action.payload,
        error: false,
      };
      return newState;
    }
    case 'POSTING_TO_CART_SUCCESS': {
      const newState = {
        ...state,
        isPosting: false,
        response_data: action.payload,
        error: false,
      };
      return newState;
    }
    case 'POSTING_TO_CART_FAILURE':
      return {
        ...state,
        isPosting: false,
        errorMessage: action.errorMessage || t`Ooops, something went wrong, please try again.`,
        error: true,
      };
    case 'ADD_SIZE':
      return {
        ...state,
        error: false,
      };
    default:
      return state;
  }
};
